// JavaScript Document
//IMAGE BLOCK
//link stylesheet
import React from "react"

export default function ImageBlock(props) {
    return(
        
        <div class={props.style}>
        
            <img id={props.id} src={props.src}></img>
        
        </div> 
        
    )   
    
}